<template>
    <div class="user-log-tab" ref="tab">

            <div v-if="$route.name === 'user-edit'">


                <div class="flex center demo-box">
                    <div class="left-box">
                        Time and date entering into:
                    </div>
                    <div class="right-box box grow">
                        <pre> {{ getDateEDTFormat(userData.created_at) }}</pre>
                    </div>
                </div>

                <div class="flex center demo-box">
                    <div class="left-box">
                        Term & Policy accepted:
                    </div>
                    <div class="right-box box grow">
                        <pre> {{ getDateEDTFormat(getTermAndPolicyAcceptedDate) }}</pre>
                    </div>
                </div>

                <div class="flex center ">
                    <div class="left-box">On which page it was:</div>
                    <div class="right-box box grow">
                        <p class="accent_text">
                            <a :href="getTermAndPolicyAcceptedPage" target="_blank">{{ getTermAndPolicyAcceptedPage }}</a>
                        </p>
                    </div>
                </div>

                <div class="flex center">
                    <div class="right-box box grow">
                      <el-table
                        :data="userLogs"
                        stripe>
                        <el-table-column
                          label="Time">
                          <template slot-scope="scope">
                            <span >{{getDateEDTFormat(scope.row.created_at)}}</span>
                          </template>
                        </el-table-column>

                        <el-table-column
                          prop="ip"
                          label="IP">
                        </el-table-column>
                        <el-table-column
                          prop="device"
                          label="Device">
                        </el-table-column>
                        <el-table-column
                          prop="platform"
                          label="Platform">
                        </el-table-column>
                        <el-table-column
                          prop="browser"
                          label="Browser">
                        </el-table-column>
                        <el-table-column
                          prop="user_agent"
                          label="User Agent">
                        </el-table-column>
                      </el-table>
                    </div>
                </div>
            </div>
            <el-pagination
              background
              layout="prev, pager, next"
              :current-page="current_page"
              @current-change="onChangePage"
              :page-count="pagerMeta.last_page">
            </el-pagination>
    </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { Message } from 'element-ui'
  import router from '../../../router/'
  import request from '../../../servises/request'
  import html2canvas from 'html2canvas';

  export default {
    name: 'UserLog',
      props: {
      isScreenProcess: Boolean,
      isUserLogScreenProcess: Boolean,
      userData: Object,
      screenshotPage: HTMLDivElement
    },
    data () {
      return {
        current_page: 1,
        pagerMeta: {},
        userLogs: []
      }
    },
    computed: {
        getTermAndPolicyAcceptedPage(){
            if (this.pagerMeta.confirm_log) {
                return `${process.env.VUE_APP_MAIN_SITE}/auth/`+this.pagerMeta.confirm_log.page
            }

            return '';
        },
        getTermAndPolicyAcceptedDate(){
            return this.pagerMeta.confirm_log ? this.pagerMeta.confirm_log.created_at : '';
        },
    },
    methods: {
      async createCanvas() {
        for (let i of [1, this.pagerMeta.last_page]) {
          this.current_page = i;
          await this.getUserLogs();

          this.screenshotPage.style.overflow = 'visible';
          this.screenshotPage.style.height = 'auto';
          const canvas = await html2canvas(this.screenshotPage, {
            scrollX: 0,
            scrollY: -window.scrollY,
            width: this.screenshotPage.offsetWidth,
            height: this.screenshotPage.scrollHeight,
          });
          const imgURL = {
            url: canvas.toDataURL('image/png'),
            name: `User Log page_${i}`,
          };

          this.$emit('addNewImage', imgURL);

          if (i === this.pagerMeta.last_page) {
            this.$emit('triggerNextTab', 'userEmailLog');
          }
          if (this.pagerMeta.last_page === 1) {
            break;
          }
        }
      },
      onChangePage(value) {
        this.current_page = value
        this.getUserLogs()
      },
      async getUserLogs() {
        const {data, meta} = await request({
          url: `/user/${this.$route.params.id}/logs`,
          method: 'get',
          params: {
            page: this.current_page
          }
        })
        this.userLogs = data
        this.pagerMeta = meta
      },
      getDateEDTFormat(date) {
        if(!date) {
          return
        }

        const options = {
          timeZone: 'America/New_York',
          year: 'numeric',
          month: 'numeric',
          day: 'numeric',
          hour: 'numeric',
          minute: 'numeric',
        };

        return new Intl.DateTimeFormat('en-US', options).format(new Date(date));
      },
    },
    watch: {
      isUserLogScreenProcess: function (val, oldVal) {
          if (val) {
            setTimeout(() => {
                this.createCanvas();
            }, 4000)

          }
      }
    },
    mounted  () {
     this.getUserLogs();
     if (this.isScreenProcess) {
        setTimeout(() => {
          this.createCanvas();
        }, 4000)
     }
    },

  }
</script>
